import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SliderInputComponent } from './slider-input.component';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { TooltipButtonModule } from '../tooltip-button/tooltip-button.module';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    SliderInputComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    TooltipButtonModule,
    FormsModule,
  ],
  exports: [
    SliderInputComponent,
  ],
  providers: [
    TranslatePipe,
  ],
})
export class SliderInputModule { }
